import React, { useEffect, useState } from "react";
import { AiOutlineLike } from "react-icons/ai";
import { FiShare2 } from "react-icons/fi";
// import Risk from '../../public/documents/Millance Documents/Millance LTD Risk warning.pdf';
// import RiskDiscloure from '../../public/documents/Millance Documents/Millance Ltd Risk Disclosure for Restricted Countries.pdf';
// import WithdrawalBonus from '../../public/documents/Millance Documents/Millance Ltd  Withdrawal Bonus – Terms & Conditions.pdf';
// import DepositBonus from '../../public/documents/Millance Documents/Welcome Bonus  Add-On Bonus Terms & Conditions.pdf';
// import SwapRefund from '../../public/documents/Millance Documents/Millance Swap Refund Program.pdf';
// import AMLPolicy from '../../public/documents/Millance Documents/AML Policy Millance.pdf';
// import MAM from '../../public/documents/Millance Documents/Millance MAM Account Policy.pdf';
// import PAMM from '../../public/documents/Millance Documents/Millance PAM Account Policy.pdf';
// import Copy from '../../public/documents/Millance Documents/Millance Copy Trading Policy.pdf';
// import POA from '../../public/documents/Millance Documents/LPOA MONEY MANAGER AGREEMENT Millance.pdf';
// import Privacy from '../../public/documents/Millance Documents/Millance Copy Trading Policy.pdf';/////////
// import Trading from '../../public/documents/Millance Documents/Millance Trading Policy.pdf';
// import Cookies from '../../public/documents/Millance Documents/Cookies Policy Millance.pdf';
// import Arbitrage from '../../public/documents/Millance Documents/Arbitrage Millance.pdf';
// import License from '../../public/documents/Millance Documents/Legal Documents.pdf';
// import Client from '../../public/documents/Millance Documents/Millance Client Agreement.pdf';
// import DepositWithdrawal from '../../public/documents/Millance Documents/Millance deposit, refund & withdrwals policy.pdf';
// import Leverage from '../../public/documents/Millance Documents/Millance Leverage & Margin Policy.pdf';
// import Dispute from '../../public/documents/Millance Documents/Millance Dispute Resolution Policy.pdf';
// import ClientFunds from '../../public/documents/Millance Documents/Millance Client Funds & Segregation Policy.pdf';

import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';

export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}


const Terms_condition = ({ meta, jsonLd }) => {

  let data = [
    { title: 'Risk Warning', category: 'Compliance', applicable: 'Global', whoit: 'All Clients', Date: 'May 2025', pdf: "Millance LTD Risk warning.pdf" },
    { title: 'Risk Disclosure for Restricted Countries', category: 'Compliance', applicable: 'Restricted Countries ', whoit: 'Clients from Restricted Regions', Date: 'May 2025', pdf: "Millance Ltd Risk Disclosure for Restricted Countries.pdf" },
    { title: 'Withdrawal Bonus Conditions', category: 'Trading Terms', applicable: 'Global', whoit: 'Trader Opting for Bonuses', Date: 'May 2025', pdf: "Millance Ltd  Withdrawal Bonus – Terms & Conditions.pdf" },
    { title: '50% Deposit & 30% Add-On Bonus', category: 'Trading Terms', applicable: 'Global', whoit: 'Bonus-Eligible Traders', Date: 'May 2025', pdf: "Welcome Bonus  Add-On Bonus Terms & Conditions.pdf" },
    { title: 'Swap Refund Conditions', category: 'Trading Benefits', applicable: 'Global', whoit: 'Long-Term traders', Date: 'May 2025', pdf: "Millance Swap Refund Program.pdf" },
    { title: 'AML Policy', category: 'Security & compliance', applicable: 'Global', whoit: 'All Clients', Date: 'May 2025', pdf: "AML Policy Millance.pdf" },
    { title: 'MAM Account Policy', category: 'Managed Accounts', applicable: 'Global', whoit: 'MAM Account Holders', Date: 'May 2025', pdf: "Millance MAM Account Policy.pdf" },
    { title: 'PAMM Account Policy', category: 'Managed Accounts', applicable: 'Global', whoit: 'PAMM Account Holders', Date: 'May 2025', pdf: "Millance PAM Account Policy.pdf" },
    { title: 'Copy Trading Policy', category: 'Trading Services', applicable: 'Global', whoit: 'Copy traders', Date: 'May 2025', pdf: "Millance Copy Trading Policy.pdf" },
    { title: 'POA Agreement', category: 'Legal Documents', applicable: 'Global', whoit: 'Managed Trading Clients', Date: 'May 2025', pdf: "LPOA MONEY MANAGER AGREEMENT Millance.pdf" },
    { title: 'Privacy Policy', category: 'Data production', applicable: 'Global', whoit: 'All Users', Date: 'May 2025', pdf: "Millance Copy Trading Policy.pdf" },
    { title: 'Trading Policy', category: 'Trading Rules', applicable: 'Global', whoit: 'Active Users', Date: 'May 2025', pdf: "Millance Trading Policy.pdf" },
    { title: 'Cookies Policy', category: 'Data & Security', applicable: 'Global', whoit: 'Website Visitors', Date: 'May 2025', pdf: "Cookies Policy Millance.pdf" },
    { title: 'Arbitrage Policy', category: 'Trading Restriction', applicable: 'Global', whoit: 'All Traders', Date: 'May 2025', pdf: "Arbitrage Millance.pdf" },
    { title: 'License Documents', category: 'Regulation & Compliance', applicable: 'Union of Comoros', whoit: 'Regulatory Authorities', Date: 'May 2025', pdf: "Legal Documents.pdf" },
    { title: 'Client Agreement', category: 'Legal Agreement', applicable: 'Global', whoit: 'All Millance clients', Date: 'May 2025', pdf: "Millance Client Agreement.pdf" },
    { title: 'Deposit & Withdrawal Policy', category: 'Transactionn', applicable: 'Global', whoit: 'Clients using Millance payments', Date: 'May 2025', pdf: "Millance deposit, refund & withdrwals policy.pdf" },
    { title: 'Leverage & Margin Policy', category: 'Trading Conditions', applicable: 'Global', whoit: 'All Traders', Date: 'May 2025', pdf: "Millance Leverage & Margin Policy.pdf" },
    { title: 'Dispute Resolution Policy', category: 'Legal & Compliance', applicable: 'Global', whoit: 'Client with Disputes', Date: 'May 2025', pdf: "Millance Dispute Resolution Policy.pdf" },
    { title: 'Client Funds & Segregation Policy', category: 'Security & Fund management', applicable: 'Global', whoit: 'All Clients', Date: 'May 2025', pdf: "Millance Client Funds & Segregation Policy.pdf" },
  ]

  const [heartActive, setHeartActive] = useState('');

  const OnLike = (title) => {
    setHeartActive(title)
  }
  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="Terms_condition">
        <div className="About-us">
          <section className="about2">
            <div className="bannercont">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-12 col-lg-6 d-flex flex-column justify-content-center mt-5">
                    <h1 className="mb-2">Terms and Conditions
                    </h1>
                    <p className="mb-3">
                      Your Trusted Partner in Trading Success
                    </p>
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <div className="girlimage">
                      <img
                        src={"/images/aboutus/About-Us-02.png"}
                        alt="logo"
                        className="img-fluid mt-5"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="container pt-5">
          {
            data?.map((e,i) => (
              <div className="careers-block-one" key={i+'faq'}>
                <div className="inner-box">
                  <div className="title-box mb-3">
                    <div className="author-box">
                      <div className="icon-box">
                        <img
                          src={"/images/aboutus/icon.png"}
                          alt="logo"
                          className="img-fluid"
                        />
                      </div>
                      <span className="text">Policy/Agreement</span>
                      <h3>{e.title}</h3>
                    </div>
                    <ul className="option-list">
                      <li>
                        <span>Last Updated Date: {e.Date}</span>
                      </li>
                      <li>
                        <button onClick={() => OnLike(e.title)} >
                          <AiOutlineLike style={{ color: e.title === heartActive ? 'green' : 'black', fill: e.title === heartActive ? 'green' : 'black' }} />
                        </button>
                      </li>
                      <li>
                        <a href="#">
                          <FiShare2 />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="info-box">
                    <ul className="info-list clearfix">
                      <li>
                        <div className="icon-box">
                          <i className="altick">
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth="0"
                              viewBox="0 0 512 512"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                            </svg>
                          </i>
                        </div>
                        <span>Category </span>
                        <p>{e.category}</p>
                      </li>
                      <li>
                        <div className="icon-box">
                          <i className="altick">
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth="0"
                              viewBox="0 0 512 512"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                            </svg>
                          </i>
                        </div>
                        <span>Applicable Jurisdiction</span>
                        <p>{e.applicable}</p>
                      </li>
                      <li>
                        <div className="icon-box">
                          <i className="altick">
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth="0"
                              viewBox="0 0 512 512"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                            </svg>
                          </i>
                        </div>
                        <span>Who It Applies To</span>
                        <p>{e.whoit}</p>
                      </li>
                    </ul>
                  </div>
                  <div className="btn-box">
                    <a href={"../../documents/Millance Documents/" + e.pdf} className="theme-btn" target="_blank">
                      <span>View Document</span>
                    </a>
                    <a className="theme-btn" href={"../../documents/Millance Documents/" + e.pdf} download target="_blank">
                      <span>PDF Format</span>
                    </a>
                  </div>
                </div>
              </div>
            ))
          }

          {/* <div className="careers-block-one">
          <div className="inner-box">
            <div className="title-box mb-3">
              <div className="author-box">
                <div className="icon-box">
                  <img
                    src={"/images/aboutus/icon.png"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <span className="text">Policy/Agreement</span>
                <h3>50% Deposit &amp; 30% Add-On Bonus</h3>
              </div>
              <ul className="option-list">
                <li>
                  <span>Last Updated Date: Mar 2024</span>
                </li>
                <li>
                  <button>
                    <AiOutlineLike />
                  </button>
                </li>
                <li>
                  <a href="#">
                    <FiShare2 />
                  </a>
                </li>
              </ul>
            </div>
            <div className="info-box">
              <ul className="info-list clearfix">
                <li>
                  <div className="icon-box">
                    <i className="altick">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                      </svg>
                    </i>
                  </div>
                  <span>Category </span>
                  <p>Trading Terms</p>
                </li>
                <li>
                  <div className="icon-box">
                    <i className="altick">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                      </svg>
                    </i>
                  </div>
                  <span>Applicable Jurisdiction</span>
                  <p>Global</p>
                </li>
                <li>
                  <div className="icon-box">
                    <i className="altick">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                      </svg>
                    </i>
                  </div>
                  <span>Who It Applies To</span>
                  <p>Bonus-Eligible Traders</p>
                </li>
              </ul>
            </div>
            <div className="btn-box">
              <a
                href="#"

                className="theme-btn"
              >
                <span>View Document</span>
              </a>
              <a
                href="#"

                className="theme-btn"
              >
                <span>PDF Format</span>
              </a>
            </div>
          </div>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default Terms_condition;
